import { render, staticRenderFns } from "./ConstructionYear.vue?vue&type=template&id=d3fa2a5a&"
import script from "./ConstructionYear.vue?vue&type=script&lang=ts&"
export * from "./ConstructionYear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports